"use client";

import React from "react";
import Gallery from "rivals/components/shared/Gallery";
import styles from "./GalleryBlock.module.scss";
import { ClientProps } from "./types";

function GalleryBlock(props: ClientProps): React.JSX.Element {
  return (
    <div className={styles.galleryContainer}>
      <Gallery {...props} />
    </div>
  );
}

export default GalleryBlock;
